<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Contents</h1>
<h2 class="TOCCT"><a href="#/int">Introduction</a></h2>
<h2 class="TOCCT"><a href="#/c01">Toolbox</a></h2>
<h2 class="TOCCT"><span href="#/c02" title="Link target outside of Sample">Trio of Buttercream Beauties</span></h2>
<h2 class="TOCCT"><span href="#/c03" title="Link target outside of Sample">Cake &amp; Cookie Recipes</span></h2>
<h2 class="TOCCT"><span href="#/c04" title="Link target outside of Sample">Fillings</span></h2>
<h2 class="TOCCT"><span href="#/c05" title="Link target outside of Sample">Presentation</span><br/><br/></h2>
<h2 class="TOCCT"><span href="#/sup" title="Link target outside of Sample">Suppliers</span><br/><br/></h2>
<h2 class="TOCCT"><span href="#/ack" title="Link target outside of Sample">About the Author &amp; Acknowledgments</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?57e7a051